import { Box, Container } from '@mui/material'
import { useState } from 'react'
import { SectionHeading } from '@/components/common'
import { faqItems } from '@/data/faq'
import { FaqItem } from './FaqItem'
import { SECTION_IDS } from '@/utils/constants'

/**
 * FAQ Section Component
 * Displays frequently asked questions with accordion
 */
export const FaqSection = () => {
  const [expanded, setExpanded] = useState<string | false>(false)

  const handleChange = (panel: string) => () => {
    setExpanded(expanded === panel ? false : panel)
  }

  return (
    <Box
      component="section"
      id={SECTION_IDS.FAQ}
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="md">
        <SectionHeading align="center" underline>
          Frequently Asked Questions
        </SectionHeading>

        <Box sx={{ mt: 4 }}>
          {faqItems.map((item) => (
            <FaqItem
              key={item.id}
              item={item}
              expanded={expanded === item.id}
              onChange={handleChange(item.id)}
            />
          ))}
        </Box>
      </Container>
    </Box>
  )
}
